export const GROUPS_REQUEST = 'DVR/GROUPS/REQUEST';
export const GROUPS_SUCCESS = 'DVR/GROUPS/SUCCESS';
export const GROUPS_FAILURE = 'DVR/GROUPS/FAILURE';
export const SEARCH_REQUEST = 'DVR/SEARCH/REQUEST';
export const SEARCH_SUCCESS = 'DVR/SEARCH/SUCCESS';
export const SEARCH_FAILURE = 'DVR/SEARCH/FAILURE';
export const SEARCH_CLEAR = 'DVR/SEARCH/CLEAR';
export const SET_GROUPS = 'DVR/GROUPS/SET';
export const SET_STATUS = 'DVR/STATUS/SET';
export const SET_CHIP = 'DVR/CHIP/SET';
export const SET_CARDVIEW = 'DVR/CARDVIEW/SET';
export const CLEAR = 'DVR/CLEAR';
export const CLEAR_HIDEABLE = 'DVR/CLEAR/HIDEABLE';
export const CLEAR_FILTER_MOBILE = 'DVR/CLEAR/MOBILE'
export const STATUS_REQUEST = 'DVR/STATUS/REQUEST';
export const STATUS_SUCCESS = 'DVR/STATUS/SUCCESS';
export const STATUS_FAILURE = 'DVR/STATUS/FAILURE';
